<template>
  <BaseModalSmall @close="$emit('close')">
    {{ $t('roster.recurring_update.heading') }}
    <template #footer>
      <BaseButton
        color="inverted"
        @click="$emit('submitSingle')"
        v-test="'roster-entry-repeat-single'"
      >
        {{ $t('roster.recurring_update.only_this') }}
      </BaseButton>
      <BaseButton
        @click="$emit('submitAll')"
        v-test="'roster-entry-repeat-all'"
      >
        {{ $t('roster.recurring_update.all_future') }}
      </BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script
  setup
  lang="ts"
>
defineEmits(['submitAll', 'submitSingle', 'close']);
</script>
